import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-color-text",
  "use": "format-color-text-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-color-text\"><path fill-rule=\"evenodd\" d=\"M0 20h24v4H0v-4Zm5.5-3L11 3h2l5.49 14h-2.25l-1.12-3H8.87l-1.12 3H5.5ZM12 5.67 9.62 12h4.76L12 5.67Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol